export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const bengaliNumerals = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
  
  const convertToBengali = (number) => {
    return String(number).split('').map(digit => bengaliNumerals[digit]).join('');
  };

  const bengaliMonths = [
    'জানুয়ারি', 'ফেব্রুয়ারি', 'মার্চ', 'এপ্রিল', 'মে', 'জুন',
    'জুলাই', 'আগস্ট', 'সেপ্টেম্বর', 'অক্টোবর', 'নভেম্বর', 'ডিসেম্বর'
  ];

  return `${convertToBengali(date.getDate())} ${bengaliMonths[date.getMonth()]}, ${convertToBengali(String(date.getFullYear()).slice(2))}`;
}; 

export const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Month is 0-indexed
  const day = date.getDate();

  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  return `${year}-${month}-${day} ${hours}:${minutes < 10 ? '0' + minutes : minutes}${ampm}`;
};